// Check https://froala.com/wysiwyg-editor/docs/plugins/ for more info on plugins

import { ZvFroalaOptions } from '@zvoove-market/shared';

const froalaLicenseKey = 'BWC6D-16D3E3E1E2B1A7A1wc2DBKSPJ1WKTUCQOd1OURPE1KDc1C-7J2A4D4B4C6E2A2F4F1H1==';

export const froalaDefaultEditorOptions: Partial<ZvFroalaOptions> = {
  // Needed to remove the Froala license banner
  key: froalaLicenseKey,
  // Needed to remove the embed.ly <powered by froala> suffix.
  embedlyKey: froalaLicenseKey,
  // Removes the "Powererd by Froala" footer, requires a license key.
  attribution: false,
  // Shows more toolbar options
  listAdvancedTypes: true,
  charCounterCount: false,
  toolbarBottom: false,
  toolbarSticky: false,
  pasteAllowLocalImages: true,
  htmlAllowComments: true,
  height: 400,
  quickInsertEnabled: false,
  useClasses: false,
  toolbarButtons: [
    'paragraphFormat',
    '|',
    'bold',
    'italic',
    'underline',
    'textColor',
    'backgroundColor',
    '|',
    'insertLink',
    'quote',
    '|',
    'formatUL',
    'formatOL',
    '|',
    'alignLeft',
    'alignCenter',
    'alignRight',
    '|',
    'outdent',
    'indent',
    '|',
    'undo',
    'redo',
  ],
};
